import React from 'react';
import { BENCH_PATH, useBenchRoute } from './routing';
import { ASSIGNMENT_PATH, READ_ASSIGNMENTS_LIST } from 'domain/shared/assignment';
import { Routes, Route } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { GlobalProtectedRoute } from 'framework/authorization';
import BenchList from './List/BenchList';

const BenchRouter = () => {
  const { listRoute } = useBenchRoute();
  return (
    <ProtectedRouter basePath={ASSIGNMENT_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_ASSIGNMENTS_LIST}>
              <BenchList />
            </GlobalProtectedRoute>
          }
        />
      </Routes>
    </ProtectedRouter>
  );
};
BenchRouter.getRouterPath = () => `${BENCH_PATH}/*`;

export default BenchRouter;
